import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const JobChangeTracker = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default JobChangeTracker